<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		:title="m.id == 0 ? '数据增加' : '数据修改'"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：" v-show="m.id!=0">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
					<el-form-item label="姓名：">
						<el-input v-model="m.name"></el-input>
					</el-form-item>
					<el-form-item label="入学日期：">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择日期" v-model="m.birthday" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-col>
					</el-form-item>
					<el-form-item label="性别：">
						<el-radio-group v-model="m.sex">
							<el-radio :label="0">男</el-radio>
							<el-radio :label="1">女</el-radio>
						</el-radio-group>
					</el-form-item>
          <el-form-item label="校区：">
            <el-select size="mini" v-model="m.campus">
              <el-option v-for="campus in campusList" :label="campus.name" :value="campus.id" :key="campus.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="m.phoneNum"></el-input>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false,
				id: 0,
				m: null,
        campusList:[],

			}
		},
		methods: {
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/campus/getList',
            {},
            function(res){
              this.campusList = res.data;
              console.log('校区',res.data);
            }.bind(this),{async:false});
      },
			// 打开
			open: function(id) {

				// this.id = id;
				this.isShow = true;
				if(id == 0){	// 如果是添加
					this.m = this.create_m();
				} else {
					//id 非 0 代表 是要修改 先查询一下，把旧值显示在input中
					this.sa.ajax('api/psdAdmin/stu/getStudentById', {stuId: id}, function(res) {
						this.m = res.data;
            this.m.sex = parseInt(this.m.sex);
						console.log(res.data);
					}.bind(this), /*{res: this.getMockData(id)}*/);
				}
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.name)) {
					return sa.error('请输入学生名称');
				}
				if(sa.isNull(m.birthday)) {
					return sa.error('请输入入学日期');
				}
        if(sa.isNull(m.sex)) {
          return sa.error('请选择性别');
        }
        if(sa.isNull(m.campus)) {
          return sa.error('请选择校区');
        }
        if(sa.isNull(m.phoneNum)) {
          return sa.error('请输入手机号');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
				if(this.m.id == 0) {
					// id == 0 为增加
          console.log(this.m);
					this.sa.ajax('api/psdAdmin/stu/addStudent', JSON.stringify(this.m), function(res) {
					  if(res.code == '0'){
              self.sa.alert('增加成功', function() {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '新增失败');
            }

					},{ contentType:"application/json;charset=UTF-8"});
				} else {
					// id != 0 为修改
					this.sa.ajax('api/psdAdmin/stu/updateStudent', JSON.stringify(this.m), function(res){
            if(res.code == '0') {
              self.sa.alert('修改成功', function () {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '修改失败');
            }
					},{ contentType:"application/json;charset=UTF-8"});
				}
			},
			// 创建一个空的model
			create_m: function() {
				return {
					id: 0,
					name: '',
          birthday:'',
          sex:'',
          campus:'',
          phoneNum:''
				}
			},
		},
		created: function(){
			this.getCampusList();
		}
	}
</script>
